module.exports = __webpack_public_path__ + "media/images/icons/circle-0387500bdc4a46df5faa6745787e3748.svg";